import { http } from "services/http";

import type {
  StuckFundsListRequest,
  StuckFundsListResponse,
  StuckFundsScanRequest,
  StuckFundsScanResponse,
} from "models/wallets.model";

export const walletsApi = {
  getStuckFunds: (data: StuckFundsListRequest = {}) =>
    http.quiet().post<StuckFundsListResponse>("/api/stuck-funds", { ...data }),
  scanStuckFunds: (data: StuckFundsScanRequest = {}) =>
    http.quiet().post<StuckFundsScanResponse>("/api/stuck-funds/scan", { ...data }),
};
